<div class="modal-body">
    <div class="modal-text-wrapper-info">
      <p class="title">{{title}}</p>
      <p class="body">{{information}}</p>
      <p class="body">{{info}}</p>
    </div>
    
    <button type="button" class="modal-btn-primary" (click)="activeModal.close('Close click')">{{positiveButton}}</button>
    <button type="button" class="modal-btn-secondary" (click)="activeModal.dismiss('')">{{negativeButton}}</button>
</div>